import { DatapointStatus, PerformanceDatapoint } from 'owa-analytics';
import { getGuid } from 'owa-guid';
import getOgmaDetectedLanguage from '../services/getOgmaDetectedLanguage';

const OGMA_CHAR_LIMIT = 10000;

export default async function getDetectedLanguage(content: string[]): Promise<string> {
    let correlationId = getGuid();
    let detectedLanguage: string = null;
    const datapoint = new PerformanceDatapoint('InlineTranslationGetDetectedLanguage');

    try {
        let plainText = content.join(' ');
        if (plainText.length > OGMA_CHAR_LIMIT) {
            // Ogma limitation. We need to trim the rest of the email content and base detection on the first 10000 characters.
            plainText = plainText.substring(0, OGMA_CHAR_LIMIT);
        }

        detectedLanguage = await getOgmaDetectedLanguage(plainText, correlationId);
        datapoint.end();
    } catch (ex) {
        const error = new Error(
            '[InlineTranslation] getOgmaDetectedLanguage failed. Error:' +
                ex +
                ' | cid:' +
                correlationId
        );
        datapoint.endWithError(DatapointStatus.ServerError, error);
    }
    return detectedLanguage;
}
